export default __webpack_public_path__ + "static/media/rock_badge.69ab3cc6.svg";